'use client';

import { FaqCardFragment } from '@/__generated__/graphql';
import FaqCardAccordion from './FaqCard.Accordion';
import FaqCardAccordionItem from './FaqCard.AccordionItem';

const FaqCard = (props: FaqCardFragment) => {
  const index = 1; // Index is irrelevant as there will only be one item

  return (
    <FaqCardAccordion>
      <FaqCardAccordionItem index={index} data={props} />
    </FaqCardAccordion>
  );
};

export default FaqCard;
